import styled, {keyframes} from "styled-components";

export const Container = styled.div`
  text-align: center;
`;

export const ButtonBackStyle = styled.button`
  background: #f2f2f2;
  border-radius: 5px;
  border: 1px solid #004070;
  padding: 0 16px;
  width: 100%;
  height: 56px;
  color: #004070;
  font-weight: normal;
  margin-top: 16px;
  transition: background 0.2s;

  ${({disabled}) => disabled && `
    cursor: default;
    background: #f2f2f2;
    border: 1px solid #9D9D9C;
    color: #9D9D9C
  `}

  ${({disabled}) => !disabled && `
  &:hover {
    background: #f2f2f2;
     border: 1px solid #246899;
     color: #246899
  }
  `}
`;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingSpinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  border-top: 2px solid grey;
  border-right: 2px solid grey;
  border-bottom: 2px solid grey;
  border-left: 4px solid #fff;
  background: transparent;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  margin-top: 5px;
`;
